import { Hero } from '../Hero';
import { ProjectsGallery } from '../ProjectsGallery';
import { AboutTeaser } from './AboutTeaser';
import { NeonLab } from './NeonLab';
import { ContactSection } from '../ContactSection';
import { PageTransition } from '../transitions/PageTransition';
import { SEOHead } from '../seo/SEOHead';

interface HomePageProps {
  isLoaded: boolean;
}

export function HomePage({ isLoaded }: HomePageProps) {
  return (
    <PageTransition>
      <SEOHead path="/" />
      <Hero isLoaded={isLoaded} />
      <NeonLab />
      <ProjectsGallery />
      <AboutTeaser />
      <ContactSection />
    </PageTransition>
  );
}
